






































































































import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import HasValidation from "@/mixins/HasValidation";

// Helpers
import { bytesToSize } from "@/helpers/file";

@Component({
  components: {
    "progress-bar": () =>
      import("@/components/app/global/fields/progressBar.vue")
  }
})
export default class FileUpload extends Mixins(HasValidation) {
  @Prop({ required: true })
  public value!: any;

  @Prop({ required: true })
  public fieldName!: string;

  @Prop({ default: false })
  public isUploading!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: 0 })
  public progress!: number;

  @Prop({ required: true })
  public hash!: string;

  @Prop({ default: "file-alt" })
  public icon!: string;

  @Prop({ required: true })
  public fileTypes!: string[];

  @Prop({ default: false })
  public allowPreview!: boolean;

  @Prop({ default: "" })
  public imageSrc!: string;

  public key = 0;
  public hoverMsg = "";

  public file: any = this.value;

  public created() {
    this.$watch("value", val => (this.file = val));
  }

  public setFile(value) {
    if (this.$_.get(value, "type")) {
      if (this.fileTypes.includes(this.$_.get(value, "type"))) {
        const newFile = {};
        newFile["fileObj"] = value;
        newFile["exists"] = true;
        this.file = newFile;
        this.$emit("input", this.file);
      } else {
        this.$store.dispatch("toast/error", {
          message: this.$t("_sentence.wrong_file_type")
        });
      }
    }
  }

  public get fieldHasError() {
    return this.hasError(this.fieldName);
  }

  public get fileExists() {
    return (!this.$_.isEmpty(this.file) && this.file.exists) || this.hash;
  }

  public get fileName() {
    return this.$_.get(this.file, "fileObj.name", "");
  }

  public get fileSize() {
    return bytesToSize(this.$_.get(this.file, "fileObj.size", 0));
  }

  public get i18n() {
    return {
      browse: this.$t("_.browse")
        .toString()
        .toLowerCase()
    };
  }

  public deleteFile() {
    this.hoverMsg = "";
    this.$emit("input", { exists: false });
    this.key++;
  }

  public viewImage() {
    this.hoverMsg = "";
    this.$emit("preview");
  }
}
